import ActivationServiceError from './ActivationServiceError'

export default ActivationServiceError
